import "../../assets/FollowupOD/scss/modules/questionnaire.scss";
import "../../assets/FollowupOD/scss/modules/custom.scss";

import { useContext, useEffect, useReducer, useState } from "react";
import { Api } from "../../api/Api";
import { getQueryString } from "../../Utility/QueryString";
import { useHistory } from "react-router-dom";
import { useFollowupLoad } from "../../Hooks/useFollowupLoad";
import { useFollowupUserQuestions } from "../../Hooks/useFollowupUserQuestions";
import { useSkippedLeads } from "../../Hooks/useSkippedLeads";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import { useForm } from "react-hook-form";
import { useUserClickStore } from "../../Hooks/useClickDetailStore";
import { TrackUserActions } from "../../Utility/TrackUserActions";
import Signature from "../Includes/Layouts/FollowupOD/Signature";
import CreditCheckFlp from "../Includes/Layouts/FollowupOD/CreditCheckFlp";
import QuestionaireFlp from "../Includes/Layouts/FollowupOD/QuestionaireFlp";
import FlpODId from "../Includes/Layouts/FollowupOD/FlpODId";
import PreviewFlpOD from "../Includes/Layouts/FollowupOD/PreviewFlpOD";
import LoaderOD from "../Includes/Layouts/FollowupOD/LoaderOD";
import CreditCheckQuestions_FLP_OD from "../Includes/Layouts/FollowupOD/CreditCheckQuestions_FLP_OD";
import CreditCheck_FLP_OD_CONFIRM from "../Includes/Layouts/FollowupOD/CreditCheck_FLP_OD_CONFIRM";
import CreditCheck_Submit_Otp_FLP_OD from "../Includes/Layouts/FollowupOD/CreditCheck_Submit_Otp_FLP_OD";
import CreditCheck_Send_Otp_FLP_OD from "../Includes/Layouts/FollowupOD/CreditCheck_Send_Otp_FLP_OD";
import VerifyDataFlpOD from "../Includes/Layouts/FollowupOD/VerifyDataFlpOD";

const FollowupOD = () => {
  const history = useHistory();
  const { loadFollowup } = useFollowupLoad();
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const { skippedLeads } = useSkippedLeads();
  // const [state, dispatch] = useReducer(QuestionnaireReducer, initialState);
  const { visitorParameters } = useContext(VisitorParamsContext);
  const [pendingQuestionnaire, setPendingQuestionnaire] = useState([]);
  const [showUserName, setUserName] = useState(null);
  const [uuid, setUuid] = useState(null);
  const [allFollowupData, setFollowupData] = useState(false);
  const [optionSelected] = useState([]);
  const [optionSelected76] = useState([]);
  const [t2aApiReqData, setT2aApiReqData] = useState({});
  const [stillAct, setStillAct] = useState("");
  const [cardOpenYr, setCardOpenYr] = useState([]);
  const [userEmail, setUserEmail] = useState();
  const [userSign, setUserSign] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const { userClickStore } = useUserClickStore();
  const { register, errors, trigger, setError, clearErrors, getValues } =
    useForm({
      mode: "onBlur",
      reValidateMode: "onChange",
      defaultValues: {},
      resolver: undefined,
      context: undefined,
      criteriaMode: "firstError",
      shouldFocusError: true,
      shouldUnregister: true,
    });
  const [loader, setLoader] = useState(true);
  const [showSlides, setShowSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState("");
  const [userData, setUserData] = useState({});
  const [creditPendingSlides, setCreditPendingSlides] = useState([]);
  const queryString = getQueryString() ?? window.location.search.substring(1);

  useEffect(() => {
    (async () => {
      const response = await Api.get(
        `/api/v1/followup/get-pending-details-od?query_string=` + queryString,
        {}
      );
      console.log(response.data.status);

      if (response.data.status === "Success") {
        let questionPending = response.data.response.slides;
        let followup_data = response.data.response.followup_data;
        let uuid = response.data.response.uuid;
        let username = response.data.response.username;
        localStorage.setItem("uuid", uuid);
        let userId = response.data.response.user_id;
        let title = response.data.response.title;
        let fname = response.data.response.first_name;
        let lname = response.data.response.last_name;
        let tMName = response.data.response.middle_name;
        let email = response.data.response.email;
        let dob_day = response.data.response.dob_day;
        let dob_yr = response.data.response.dob_yr;
        let dob_month = response.data.response.dob_month;
        let postcode = response.data.response.postcode;
        let address_line1 = response.data.response.address_line1;
        let address_line2 = response.data.response.address_line2;
        let addressLine3 = response.data.response.address_line3;
        let addressLine4 = response.data.response.address_line4;
        let town = response.data.response.town;
        let country = response.data.response.country;
        let county = response.data.response.county;
        let t2a_status = response.data.response.t2a_status;
        let split_name = response.data.response.split_name;
        let userSign = response.data.response.sign;
        let selectedBank = response.data.response.lender;
        let cc_pending_question = response.data.response.cc_pending_question;
        localStorage.setItem("flp_source", followup_data.atp_sub6);
        localStorage.setItem("allFollowupData", JSON.stringify(followup_data));
        localStorage.setItem("t2aValidation", t2a_status ? t2a_status : "0");
        localStorage.setItem("split_name", split_name);
        let Source = response.data.response.source;
        let txtEmail = response.data.response.email;
        let txtPhone = response.data.response.phone;
        visitorParameters.email = email || false;
        let slidesToShow = Object.entries(response.data.response)
          .filter(([key, value]) => value === "show")
          .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
          }, {});

        setT2aApiReqData({
          uuid: uuid,
          fName: fname,
          lName: lname,
          pCode: postcode,
          addressLine1: address_line1,
          day: dob_day,
          month: dob_month,
          year: dob_yr,
          addressLine2: address_line2,
          postTown: town,
          country: country,
          title: title,
          addressLine3: addressLine3,
          addressLine4: addressLine4,
          county: county,
        });
        setUserData({
          userId: userId,
          uuid: uuid,
          title: title,
          txtFName: fname,
          txtLName: lname,
          txtMName: tMName,
          DobDay: dob_day,
          DobMonth: dob_month,
          DobYear: dob_yr,
          txtPostCode: postcode,
          txtHouseNumber: address_line1,
          txtAddress2: address_line2,
          txtAddress3: addressLine3,
          addressLine4: addressLine4,
          txtCounty: county,
          country: country,
          txtTown: town,
          source: Source,
          txtEmail: txtEmail,
          txtPhone: txtPhone,
          split_name: split_name,
        });
        setUserSign(userSign);
        setUserName(username);
        setUuid(uuid);
        setFollowupData(followup_data);
        setUserEmail(email);
        setSelectedBank(selectedBank);
        console.log("selectedBank", selectedBank);
        setCreditPendingSlides(cc_pending_question);

        const flpResponse = await loadFollowup(
          "followup_load",
          followup_data,
          "followup-od",
          queryString,
          "od"
        );

        let slides = Object.keys(slidesToShow);
        console.log("slides", slidesToShow);
        if (slides.length === 0) {
          history.push(`/ThankyouODUFL4?uuid=${uuid}`);
        }
        setShowSlides(slides);
        setTimeout(() => {
          setPendingQuestionnaire(questionPending);
          setLoader(false);
        }, 3000);
      } else {
        console.log("error");

        history.push(`/ThankyouODUFL4`);
        return false;
      }
    })();
  }, []);

  const saveUserAction = (e) => {
    try {
      const userDetails = TrackUserActions(e);
      if (userDetails) {
        const { page, action, click_type, source, user_uuid } = userDetails;

        userClickStore(user_uuid, page, action, click_type, source);
      }
    } catch (error) {
      console.error("Error saving user action:", error);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.getAttribute("data-click-id")) {
        saveUserAction(e);
      }
    };

    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    if (showSlides.length > 0) {
      slideChange(showSlides);
    }
  }, [showSlides]);

  const slideChange = (pendingArr) => {
    let pendingCount = pendingArr.length;
    console.log("pendingArr", pendingArr, pendingArr[0], uuid);
    if (pendingCount === 0) {
      history.push(`/ThankyouODUFL4?uuid=${uuid}`);
      return false;
    }
    setCurrentSlide(pendingArr[0]);
  };

  const removeFromPending = (slidename) => {
    const index = showSlides.indexOf(slidename);
    if (index > -1) {
      showSlides.splice(index, 1);
    }
    console.log("showSlides", showSlides);
    slideChange(showSlides);
  };

  return (
    <>
      <div className={`FollowupOD`}>
        {loader && <LoaderOD showUserName={showUserName} showLoad={true} />}
        {!loader && currentSlide == "signature" && (
          <Signature
            allFollowupData={allFollowupData}
            uuid={uuid}
            cfirstName={showUserName}
            removeFromPending={removeFromPending}
            setUserSign={setUserSign}
          />
        )}

        {currentSlide == "creditCheck_Questions" && (
          <CreditCheckQuestions_FLP_OD
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
            selectedBank={selectedBank}
            creditPendingSlides={creditPendingSlides}
          />
        )}
        {!loader && currentSlide == "send_otp_flp" && (
          <CreditCheck_Send_Otp_FLP_OD
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}
        {!loader && currentSlide == "submit_otp_flp" && (
          <CreditCheck_Submit_Otp_FLP_OD
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}
        {!loader && currentSlide == "otp_confirmation_page" && (
          <CreditCheck_FLP_OD_CONFIRM
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}
        {!loader && currentSlide == "questionnaire" && (
          <QuestionaireFlp
            questionSlides={pendingQuestionnaire}
            allFollowupData={allFollowupData}
            updatePending={setPendingQuestionnaire}
            removeFromPendingFollowup={removeFromPending}
          />
        )}
        {!loader && currentSlide == "verify" && (
          <VerifyDataFlpOD
            uuid={uuid}
            t2aApiReqData={t2aApiReqData}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}

        {!loader &&
          (currentSlide == "preview" || currentSlide == "meritPage") && (
            <PreviewFlpOD
              uuid={uuid}
              removeFromPending={removeFromPending}
              meritPage={showSlides.includes("meritPage")}
              queryString={queryString}
              allFollowupData={allFollowupData}
              userSign={userSign}
            />
          )}

        {!loader && currentSlide == "idUpload" && (
          <FlpODId
            uuid={uuid}
            removeFromPending={removeFromPending}
            allFollowupData={allFollowupData}
          />
        )}
      </div>
    </>
  );
};

export default FollowupOD;
